module.exports = currencies;